import { Injectable } from '../../helpers';

export class CheckMobileService extends Injectable {

    static get $inject() {
        return [
            '$window',
        ];
    }

    constructor(window) {
        super();
        this.navigator = window.navigator;
        this.document = window.document;
    }

    getMobileOperatingSystem() {

        const userAgent = this.navigator.userAgent || this.navigator.vendor || this.$window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return 'Windows Phone';
        }

        if (/android/i.test(userAgent)) {
            return 'Android';
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return 'iOS';
        }

        return false;
    }

    isMobile() {

        return !!this.getMobileOperatingSystem();
    }
}


// WEBPACK FOOTER //
// ./src/app/services/check-mobile.service.js